import $ from 'jquery';

let key = 'has_seen_notification_';

function Notify(element) {
  this.element = element;
  this.$element = $(element);
  this.clickHandler = $.proxy(this.clickHandler, this);
  this.storageKey = this.createStorageKey();
  this.hasSeen = this.getVariable();
  this.init();
}

Notify.prototype = {
  init() {
    if (!this.hasSeen) {
      this.addBehaviors();
      this.show();
    }
  },
  createStorageKey() {
    const elem = $('.node', this.element);
    const id = elem.eq(0).attr('id');
    key += /(\d+)/.exec(id)[0];
    return key;
  },
  getVariable() {
    // Get the current filter from session storage
    return sessionStorage.getItem(this.storageKey) || false;
  },
  setVariable() {
    // Set the current filter into session storage
    sessionStorage.setItem(this.storageKey, true);
  },
  clickHandler(event) {
    event.stopPropagation();
    const $block = $(event.target).filter(this.element);
    const $button = $(event.target).filter('.block-content');
    // Set seen variable
    this.setVariable();
    // If the button or background was clicked, hide the notification
    if ($block.length || $button.length) this.hide();
  },
  hide() {
    this.$element.removeClass('show');
  },
  show() {
    this.$element.addClass('show');
  },
  addBehaviors() {
    this.$element.bind('click', this.clickHandler);
  },
};

export default Notify;



// WEBPACK FOOTER //
// ./Notify.js